import { render, staticRenderFns } from "./V2PageLoading.vue?vue&type=template&id=82a5d5cc&"
import script from "./V2PageLoading.vue?vue&type=script&lang=js&"
export * from "./V2PageLoading.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports